import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router';
import {IonRouterLink, IonIcon} from '@ionic/react';
import {useRecoilState, useSetRecoilState} from 'recoil';
import {warning} from 'ionicons/icons';
import {isValidEmail} from '../utilis/isValidEmail';
import {chosenColorsArray} from '../state/colors';
import {colorDeclarationsProjectName} from '../state/colorDeclarations';
import {declarationsCustomerMail} from '../state/cutomerMail';
import actions from '../api/colorDeclarations';
import useFetchColorsWithBatchNumber from '../hooks/useFetchColorsWithBatchNumber';
import UICardHeader from '../components/UICommon/UICardHeader';
import UIStackedInput from '../components/UICommon/UIStackedInput';
import UIModal from '../components/UICommon/UIModal';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';


const CreateColorDeclarationPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [formErrorMessages, setFormErrorMessages] = useState({projectName: '', customerEmail: ''});
  const [selectedColorsId, setSelectedColorsId] = useState([]);
  const [projectName, setProjectName] = useRecoilState<string>(colorDeclarationsProjectName);
  const [customerMail, setCustomerMail] = useRecoilState<string>(declarationsCustomerMail);
  const [chosenColors, setChosenColors] = useRecoilState<any>(chosenColorsArray);
  const {
    isLoading: isColorsWithBatchNumberLoading,
    isError: isColorsWithBatchNumberError,
    mutate: mutateFetchColorsWithBatchNumber,
    data: colorsWithBatchNumberData,
  } = useFetchColorsWithBatchNumber(selectedColorsId);
  const setChosenColorsArray = useSetRecoilState(chosenColorsArray);
  const {id} = useParams<any>();
  const history = useHistory();

  useEffect(() => {
    if (id != null) {
      setLoading(true);
      actions.fetchSingleColorDeclaration(id)
          .then((res: any) => {
            setProjectName(res?.data?.name);
            if (res?.data?.client !== null) {
              setCustomerMail(res?.data?.client);
            }
            const chosenColorsFromDraft: any = [];
            for (let i = 0; i < res?.data?.colors?.length; i++) {
              const tmpChoosenColors = {
                batchno: res?.data?.colors[i].name,
                created: res?.data?.colors[i].created_at,
                updated: res?.data?.colors[i].updated_at,
                id: res?.data?.colors[i].color.id,
                name: res?.data?.colors[i].color.name,
                brand: res?.data?.colors[i].color.brand,
              };
              chosenColorsFromDraft.push(tmpChoosenColors);
            }
            setChosenColorsArray(chosenColorsFromDraft);
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
            setError(true);
          });
    } else {
      setSelectedColorsId(chosenColors.map((color: any) => color?.id));
    }
  }, [id]);

  useEffect(() => {
    if (selectedColorsId?.length > 0 && !(id != null)) mutateFetchColorsWithBatchNumber();
  }, [selectedColorsId]);

  useEffect(() => {
    if (colorsWithBatchNumberData?.length > 0) {
      const tmpChosenColors = chosenColors.map((chosenColor: any) => {
        const matchingColor = colorsWithBatchNumberData?.find((color: any) => color?.id === chosenColor?.id);
        if (matchingColor) {
          return {
            ...chosenColor,
            batchno: matchingColor.batchno.name,
            created: matchingColor.batchno.created_at,
            updated: matchingColor.batchno.updated_at,
          };
        };
        return chosenColor;
      });
      setChosenColors(tmpChosenColors);
    }
  }, [colorsWithBatchNumberData]);

  const saveColorDeclaration = (status: string) => {
    if (!validate()) return;
    let isChosenColorsValid = true;
    const colors = [] as any[];
    const tmpChosenColors = [...chosenColors];
    tmpChosenColors.forEach((el: any) => {
      if (el.batchno.length == 0 || el.batchno.length > 20) {
        isChosenColorsValid = false;
      }
      colors.push({
        name: el.batchno,
        color: el.id,
      });
    });
    if (!isChosenColorsValid) return;
    const data = {
      name: projectName,
      colors: colors,
      status: status,
      client: customerMail,
    };
    setLoading(true);
    if (id != null) {
      actions.updateSingleColorDeclaration(id, data).then(() => {
        setLoading(false);
        history.push('/fargdeklaration');
      }).catch(() => {
        setLoading(false);
        setError(true);
      });
    } else {
      actions.addColorDeclaration(data).then(() => {
        setLoading(false);
        history.push('/halsodeklaration');
      }).catch(() => {
        setLoading(false);
        setError(true);
      });
    }
  };

  const handleProjectNameChange = (projectName: string): void => {
    setProjectName(projectName);
    setFormErrorMessages({projectName: '', customerEmail: formErrorMessages.customerEmail});
  };

  const handleEmailChange = (email: string): void => {
    setCustomerMail(email);
    setFormErrorMessages({projectName: formErrorMessages.projectName, customerEmail: ''});
  };

  const validate = (): boolean => {
    const errors = {customerEmail: '', projectName: ''};
    if (!customerMail) {
      errors.customerEmail = 'Ange din e-postadress';
    } else if (!isValidEmail(customerMail)) {
      errors.customerEmail = 'E-postadressen är ogiltig';
    }
    if (!projectName) {
      errors.projectName = 'Ange projektnamn';
    }
    setFormErrorMessages(errors);
    return errors.customerEmail.length == 0 && errors.projectName.length == 0;
  };


  const removeChosenColor = (id: number) => {
    const tmpChosenColors = [...chosenColors];
    if (tmpChosenColors.filter((el: any) => el.id === id).length > 0) {
      for (let i = 0 as number; i < tmpChosenColors.length; i++) {
        if (tmpChosenColors[i].id === id) {
          tmpChosenColors.splice(i, 1);
          setChosenColors(tmpChosenColors);
        }
      }
    }
  };

  const handleChange = (id: number, event: any) => {
    const tmpChosenColors = [...chosenColors];
    if (tmpChosenColors.filter((el: any) => el.id === id).length > 0) {
      for (let i = 0 as number; i < tmpChosenColors.length; i++) {
        if (tmpChosenColors[i].id === id) {
          const tmpItem = {...tmpChosenColors[i]};
          tmpItem.batchno = event;
          tmpChosenColors[i] = tmpItem;
          setChosenColors(tmpChosenColors);
        }
      }
    }
  };

  const isDateCorrect = (date: string) => {
    const then = new Date(date);
    const now = new Date();
    const msBetweenDates = Math.abs(then.getTime() - now.getTime());
    const daysBetweenDates = msBetweenDates / (24 * 60 * 60 * 1000);
    if (daysBetweenDates < 365) {
      return true;
    } else {
      return false;
    }
  };

  return (loading || isColorsWithBatchNumberLoading) ? <UIModal message='Läser in...'/> :
  (error || isColorsWithBatchNumberError) ? <UIErrorIndicator/> : (
    <div className={
      'px-6 h-full flex flex-col justify-between font-Outfit md:max-h-[82vh] overflow-y-scroll ' +
      'md:overflow-hidden pt-2'}>
      <div className='overflow-y-scroll md:max-h-[65vh] pt-2 flex flex-col'>
        <UICardHeader title="Ny Färgdeklaration" padding={false}/>
        <div
        >
          <UIStackedInput
            text={projectName!}
            setText={(projectName: string) => handleProjectNameChange(projectName)}
            labelText="Projektnamn"
            placeholder='exempel: Harry Potter sleeve'
            badInput={formErrorMessages.projectName.length !== 0 ? `${formErrorMessages.projectName}` : ''}
            textStyle="md:max-w-[50%] font-medium"/>
          <UIStackedInput
            text={customerMail!}
            setText={(email: string) => handleEmailChange(email)}
            type='email'
            inputMode='email'
            labelText="Kundens epostadress"
            placeholder='kund@epost.se'
            badInput={formErrorMessages.customerEmail.length !== 0 ? `${formErrorMessages.customerEmail}` : ''}
            textStyle="md:max-w-[50%] font-medium mb-4"/>
        </div>
        <IonRouterLink
          routerLink='/fargdeklaration/choose-color'
          className={
            'font-Outline mt-2 md:mt-2 font-normal text-sm bg-navy-primary text-white rounded-lg py-4 leading-4 ' +
            ' pl-2 pr-2 mb-2  md:w-[200px] w-full whitespace-nowrap'}
        >Klicka här för att välja färg</IonRouterLink>
        <div className='py-5 md:max-w-[50%]'>
          {chosenColors && chosenColors.length > 0 && chosenColors.map((el : any) => (
            <div
              key={el.id}
              className='text-sm font-Manrope font-semibold text-navy-black pb-2 flex justify-between'
            >
              {el.name} {el.brand ? '- ' + el.brand : ''}
              <button
                className='underline mr-5 md:mr-0 text-red-500'
                onClick={() => removeChosenColor(el.id)}
              >
                  Ta bort
              </button>
            </div>
          ))}
        </div>
        <div className='space-y-2'>
          {chosenColors && chosenColors.length > 0 && chosenColors.map((el : any) => (
            <div key={el.id} className='flex flex-row relative'>
              <UIStackedInput
                labelText={`${el.name} ${el.brand ? '- ' + el.brand : ''}`}
                text={el.batchno}
                onChange={(e: any) => handleChange(el.id, e.detail.value!)}
                placeholder="exempel: 98464c"
                style="border pl-5 relative"
                textStyle='md:w-1/2 w-full font-medium'
                badInput={!el.batchno ? 'Ange ett batchnummer' :
                    el.batchno.length > 20 ? 'Batchnumret är ogiltigt' : ''}
              />
              {(el.created != null && el.updated != null) && (
                <>
                  {(!isDateCorrect(el.updated) && !isDateCorrect(el.updated)) && (
                    <div
                      className="pl-2 md:pl-5 text-11 max-w-[120px] pb-5 md:pb-0 md:max-w-[180px] leading-3 md:w-1/2
                      flex items-center justify-end md:justify-between flex-col md:flex-row space-y-2">
                      <IonIcon id={el.id} icon={warning} className='text-yellow-500 text-2xl md:text-4xl'/>
                      <span className='md:w-4/5 md:pl-5 text-black-ink'>
                      Observera! Färg med batchnummer:
                        <span className='font-semibold'> {el.batchno} </span>
                      deklarerades för mer än 12 månader sen.
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      {(chosenColors && chosenColors.length > 0) && (
        <div className='flex flex-col-reverse md:flex-row md:space-x-6 justify-center md:fixed w-full bg-white
        md:bottom-12 pt-5 pb-5 md:pb-0'>
          {id != null ? (
              <button
                onClick={() => saveColorDeclaration('published')}
                className={
                  `font-Outline mt-2 md:mt-0 font-normal text-sm bg-navy-primary text-white rounded-lg py-4 ` +
                ' leading-4 md:w-[150px] w-full'}
              >Publicera</button>
          ) : (
            <>
              <button
                onClick={() => saveColorDeclaration('draft')}
                className={
                  `font-Outline font-normal text-sm bg-gray-button text-navy-primary rounded-lg py-4 ` +
              'leading-4 md:w-[150px] w-full mt-3 md:mt-0'}
              >Spara som utkast</button>
              <button
                onClick={() => saveColorDeclaration('published')}
                className={
                  `font-Outline mt-2 md:mt-0 font-normal text-sm bg-navy-primary text-white rounded-lg py-4 ` +
              ' leading-4 md:w-[150px] w-full'}
              >Publicera</button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CreateColorDeclarationPage;
